import { useEffect, useState } from "react";

import { ImageViewer } from "../image-viewer";
import { FileProperties } from "./file-properties";
import { getContentType } from "./get-content-type";
import { SelectionAction } from "./selection-action";
import { ViewerPrefs } from "./url-fragment";

interface ImageFileViewerProps {
  content: string | Uint8Array;
  properties: FileProperties;
  versionId?: string;
  initialView?: ViewerPrefs;
  onSelectionChange?: (action: SelectionAction) => void;
}

export const ImageFileViewer = ({
  content,
  properties,
  versionId,
  initialView,
  onSelectionChange,
}: ImageFileViewerProps) => {
  const contentType = getContentType(properties.extension);
  const [imageObjectUrl, setImageObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (ArrayBuffer.isView(content)) {
      const blob = new Blob([content as Uint8Array<ArrayBuffer>], { type: contentType });
      const url = URL.createObjectURL(blob);
      setImageObjectUrl(url);
      return () => {
        URL.revokeObjectURL(url);
        setImageObjectUrl(null);
      };
    } else {
      setImageObjectUrl(content);
    }
  }, [content, contentType]);

  if (!imageObjectUrl) return null;

  return (
    <ImageViewer
      src={imageObjectUrl}
      alt={properties.name || properties.displayFileName || "Image"}
      versionId={versionId}
      initialView={initialView}
      onSelectionChange={onSelectionChange}
    />
  );
};
